function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpensify = function SvgExpensify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34 73h32v-9.5H45.7v-8.9H63v-9.7H45.7v-8.5H66V27H34v46z",
    style: {
      fill: "#0b1b34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 50c0 9.6-3.4 18.4-9 25.3l7.1 7.1c7.4-8.7 11.9-20 11.9-32.4 0-12.2-4.4-23.4-11.6-32l-7.1 7.1C86.7 31.9 90 40.6 90 50z",
    style: {
      fill: "#03d47c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3 81c-6.9 5.6-15.7 9-25.3 9-9.4 0-18.1-3.3-24.9-8.7L18 88.4c8.7 7.3 19.9 11.6 32 11.6 12.4 0 23.7-4.5 32.4-11.9L75.3 81z",
    style: {
      fill: "#0185ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3 75.7C13.5 68.7 10 59.8 10 50c0-22.1 17.9-40 40-40 9.8 0 18.7 3.5 25.7 9.3l7.1-7.1C74 4.6 62.5 0 50 0 22.4 0 0 22.4 0 50c0 12.5 4.6 24 12.2 32.8l7.1-7.1z",
    style: {
      fill: "#fed607"
    }
  }));
};
export default SvgExpensify;